import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-logo',
  templateUrl: './menu-logo.component.html',
  styleUrls: ['./menu-logo.component.scss']
})
export class MenuLogoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
